export default __webpack_public_path__ + "static/media/bedroom1.21503db7.wav";